export const compareVersions = (version1, version2) => {
  const v1parts = version1.toString().split('.').map(Number)
  const v2parts = version2.toString().split('.').map(Number)
  const maxLength = Math.max(v1parts.length, v2parts.length)

  for (let i = 0; i < maxLength; i++) {
    const v1 = v1parts[i] || 0
    const v2 = v2parts[i] || 0

    if (v1 < v2) return -1
    if (v1 > v2) return 1
  }
  return 0
}
